import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseService } from '../../base';
import { FulfilmentRouteLine, FulfilmentRouteProposal } from '../../../models/sales';

@Injectable({
  providedIn: 'root',
})
export class FulfilmentRouteService extends TmsWebBaseService {
  // Fired by an action that is KNOWN to have re-derived an order's routes - confirming the
  // order, which creates the make POs and with them the component demand each route hangs
  // off. The Routes tab still carries its Refresh button for everything else: a route also
  // moves on a pick, a cut or a transfer arriving, none of which this screen can see.
  public refreshDetails = new Subject<void>();

  constructor() {
    super('FulfilmentRoute');
  }

  // The demand behind an order, with each row's route and whether it can still be changed.
  getForOrder(salesOrderHeaderId: string): Observable<FulfilmentRouteLine[]> {
    return this.httpService.get<FulfilmentRouteLine[]>(`${this.apiUrl}/GetForOrder/${salesOrderHeaderId}`);
  }

  // What the matrix would propose, and why - shown alongside an override so the user can see
  // what they are overriding.
  propose(salesOrderLineId: string, sourceWarehouseId?: string): Observable<FulfilmentRouteProposal> {
    // The source warehouse is a query parameter, and the proposal is meaningless without it:
    // the matrix compares the SOURCE warehouse's country to the local fulfilment country, so
    // omitting it makes every line come back "source unknown - no stock allocated yet".
    const query = sourceWarehouseId ? `?sourceWarehouseId=${sourceWarehouseId}` : '';
    return this.httpService.get<FulfilmentRouteProposal>(`${this.apiUrl}/Propose/${salesOrderLineId}${query}`);
  }

  // One demand row, or every changeable row on the order.
  override(model: { demandId?: string; salesOrderHeaderId?: string; route: string }): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/Override`, model);
  }

  // Drop the override and let the matrix decide again.
  clearOverride(demandId: string): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/ClearOverride/${demandId}`, {});
  }

  // The raw-material rows behind a make PO: which fabric, how much, and where it is on the
  // RM journey (RM Allocated / Staged for Cutting / RM Cut / Complete).
  getRawMaterialsForPurchaseOrder(purchaseOrderHeaderId: string): Observable<FulfilmentRouteLine[]> {
    return this.httpService.get<FulfilmentRouteLine[]>(
      `${this.apiUrl}/GetRawMaterialsForPurchaseOrder/${purchaseOrderHeaderId}`,
    );
  }
}
